jQuery(($) => {

    var $centers = $('.js-centers'),
        $address = $('.js-address'),
        $distance = $('.js-distance');

    function getCoordinates(position) {
        var options = {};

        if (position && position.coords) {
            options.lat = position.coords.latitude;
            options.lng = position.coords.longitude;
        }

        return options;
    }

    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴
    // ∟Geolocate
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴
    function geolocate(cb) {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(cb, cb);
        } else {
            cb();
        }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // _Distance
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴
    // ∟GetDistance
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴

    // function getDistance(position) {
    //     var options = getCoordinates(position);

    //     options.action = WPVARS.actions.get_distance;

    //     if ($distance.data('post_id')) {
    //         options.post_id = $distance.data('post_id');
    //     }

    //     $distance.trigger('updating');

    //     $.post(WPVARS.ajaxurl, options, function (response) {
    //         if (response.success) {
    //             $distance.trigger('updated', response.data.html);
    //         } else {
    //             $distance.trigger('error', response.data.html);
    //         }
    //     });
    // }

    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴
    // ∟Update
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴

    // $distance.on('update', function () {
    //     getDistance();
    // });

    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴
    // ∟Load
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴

    // $distance.load(function () {
    //     geolocate(getDistance);
    // });

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // _Centers
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴
    // ∟GetCenters
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴

    // function getCenters(position) {
    //     var options = getCoordinates(position);

    //     options.action = WPVARS.actions.get_centers;

    //     if ($address.length && $address.val()) {
    //         options.address = $address.val();
    //     }

    //     if ($centers.length && $centers.data('brand')) {
    //         options.brand = $centers.data('brand');
    //     }

    //     if ($centers.find('.js-center[data-post_id]').length) {
    //         options.posts = $centers.find('.js-center[data-post_id]').map(function () {
    //             return $(this).data('post_id');
    //         }).get();
    //     }

    //     $centers.trigger('updating');

    //     $.post(WPVARS.ajaxurl, options, function (response) {
    //         if (response.success) {
    //             if (response.data.address) {
    //                 $address.val(response.data.address);
    //             }

    //             $centers.trigger('updated', response.data.html);
    //         } else {
    //             $centers.trigger('error', response.data);
    //         }
    //     });
    // }

    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴
    // ∟Update
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴

    // $centers.on('update', function () {
    //     getCenters();
    // });

    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴
    // ∟Load
    //∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴∵∴

    // $centers.load(function () {
    //     geolocate(getCenters);
    // });
});